<template>
  <nav class="navbar navbar-expand navbar-light bg-white">
    <a class="sidebar-toggle d-flex mr-2" @click="toggle">
      <i class="hamburger align-self-center"></i>
    </a>

    <div class="navbar-collapse collapse">
      <ul class="navbar-nav ml-auto"></ul>
    </div>
  </nav>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Topbar",
  methods: {
    ...mapActions({
      toggle: "sidebar/toggle"
    })
  }
};
</script>
